import Header from "../header/header";
import Footer from "../footer/footer";
import styles from "./layout.module.css"
import {useEffect, useState} from "react";
import {deleteCookie, getCookies, hasCookie, setCookie} from "cookies-next";
import Link from "next/link";

let popupChildren;

export default function Layout({children}) {
    const [cart, setCart] = useState(null);
    const [total, setTotal] = useState(null);
    const [totalTax10, setTotalTax10] = useState(0.0);
    const [totalTax13, setTotalTax13] = useState(0.0);
    const [totalTax20, setTotalTax20] = useState(0.0);
    const [error, setError] = useState("");

    useEffect(()=>
    {
        if(!hasCookie("cookies_accepted")){
            let cookiePopup = document.getElementById("cookiePopup");
            cookiePopup.classList.add(styles.showCookiePopup);
        }
    }, [])

    async function removeCookieProduct(key) {
        deleteCookie(key);
        setCart(await initCart());
    }

    async function checkDelivery(quantity){
        try{
            let res = await fetch(`https://api.gisperg.wine/api/Delivery/ValidDelivery?quantity=${quantity}`, {
                method: "GET",
                mode:"cors",
            });
            if(res.status == 200) {
                var json = await res.json();
                
                return json;
            }else{
                setError("Leider ist ein Fehler aufgetreten. Bitte probieren Sie es noch einmal!");
            }
            return res.status;
        } catch(err){
            
            setError("Leider ist ein Fehler aufgetreten. Bitte probieren Sie es noch einmal!");
        }
    }

    async function initCart() {
        const rows = [];
        let total = 0.0;
        let totalTax10 = 0.0;
        let totalTax13 = 0.0;
        let totalTax20 = 0.0;
        let totalQuantity = 0;
        let cookies = getCookies();

        for (const cookie in cookies) {
            // Catch both cookie families. Product (vintage) cookies stay on
            // the `cart-product-` prefix; package cookies use
            // `cart-package-` and carry a `kind: "package"` marker plus an
            // already-summed price + takesSpace so we can render them
            // without an extra fetch.
            if(!(cookie.startsWith("cart-product-") || cookie.startsWith("cart-package-"))) continue;
            let product = JSON.parse(decodeURIComponent(cookies[cookie]));

            total += (product.count * product.price);
            if(product.taxRate == 13.0)
                totalTax13 += ((product.count * product.price) *13) / 113;
            if(product.taxRate == 20.0)
                totalTax20 += ((product.count * product.price) *20) / 120;
            if(product.taxRate == 10.0)
                totalTax10 += ((product.count * product.price) *10) / 110;
            totalQuantity += product.count * (product.takesSpace ?? 0);
            rows.push(
                <div key={cookie} id={cookie}>
                    <p className="annotation">{product.name}{product.capacity ? ` ${product.capacity}` : ''}</p>
                    <p className="annotation">{product.count} x {(Math.round( product.price * 100)/ 100).toFixed(2)} €</p>
                    <p className="annotation underline" style={{cursor:"pointer"}} onClick={() => removeCookieProduct(cookie)}>entfernen</p>
                </div>);
        }
        
        if(!(await checkDelivery(totalQuantity))){
                setError("Die Bestellmenge muss ein Vielfaches von 6 betragen. (Magnum Flaschen zählen aus Verpackungsgründen aufgrund ihrer Größe als 2 Flaschen)");
        }else{
            setError("");
        }
        setTotal(total);
        setTotalTax10(totalTax10);
        setTotalTax13(totalTax13);
        setTotalTax20(totalTax20);
        return rows;
    }

    async function toggleCart(){
        let slideout = document.getElementById("cart_slideout");
        if (slideout.classList.contains(styles.visible)) {
            slideout.classList.remove(styles.visible);
        } else {
            setCart(await initCart());
            
            slideout.classList.add(styles.visible);
        }

    }

    function acceptCookies() {
        setCookie("cookies_accepted", true);
        let cookiePopup = document.getElementById("cookiePopup");
        cookiePopup.classList.remove(styles.showCookiePopup);
    }

    async function updateCart(){
        setCart(await initCart());
    }

    return(
        <>
            <Header toggleCart={toggleCart}/>
                <div className={styles.main}>
                    <div className={`horizontal ${styles.completeCart}`}>
                        <div className={styles.shopmark} onClick={toggleCart}>
                            <img alt="Warenkorb öffnen" src="/images/shopmark.webp" className={styles.cartImage} width="65" height="54"/>
                        </div>
                        <div id="cart_slideout" className={styles.cart}>
                            {/* Close-button in the top-right — only shown on
                                mobile (CSS-controlled), because the desktop
                                shopmark also toggles the slideout. */}
                            <button
                                type="button"
                                aria-label="Warenkorb schließen"
                                className={styles.mobileCartClose}
                                id="cart_close"
                                onClick={toggleCart}
                            >×</button>
                            <div className={styles.cartProducts}>
                                {cart}
                            </div>
                            {cart == null || cart.length == 0 && <div className="center-text"><p className="narrow">Kein Produkte im Warenkorb</p> <p className="narrow underline"><Link href="/weinkauf/shop">Zum Shop</Link></p></div>}
                            <hr size="1" width="90%"/>
                            <p className="narrow">zzgl. Versandkosten</p>
                            <p className={`narrow size-14 ${totalTax10 == 0.0 && "hidden"}`}>inkl. 10% MwSt. {(Math.round( totalTax10 * 100)/ 100).toFixed(2)} €</p>
                            <p className={`narrow size-14 ${totalTax13 == 0.0 && "hidden"}`}>inkl. 13% MwSt. {(Math.round( totalTax13 * 100)/ 100).toFixed(2)} €</p>
                            <p className={`narrow size-14 ${totalTax20 == 0.0 && "hidden"}`}>inkl. 20% MwSt. {(Math.round( totalTax20 * 100)/ 100).toFixed(2)} €</p>
                            <hr size="1" width="90%"/>
                            <p className="narrow">Zwischensumme</p>
                            <p className="narrow" style={{marginTop:0}}>{`${(Math.round( total * 100)/ 100).toFixed(2)} €`}</p>
                            {error != "" && <p style={{color:"red", margin:"2rem", textAlign:"center"}}>{error}</p>}
                            {error == "" && <Link href="/weinkauf/shop/kassa"><p className="annotation underline" style={{cursor:"pointer"}}>Zur Kassa</p></Link>}
                            <hr size="1" width="90%"/>
                        </div>
                    </div>
                    {children}
                </div>
                <div className={styles.cookiePopup} id="cookiePopup">
                    <div className="horizontal">
                        <p>Wir benutzen nur Cookies auf unserer Website die, die Funktionalität der Website(Onlineshops) gewährleisten. Wenn Sie auf "Akzeptieren" klicken, stimmen Sie zu, dass wir diese speichern dürfen. </p>
                        <p className="button x2 primary" onClick={()=> acceptCookies()}>Akzeptieren</p>
                    </div>
                </div>
            <Footer/>
        </>
    );
}